var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefit-item"},[_c('div',{staticClass:"benefit-image"},[_c('img',{staticClass:"benefit-icon",attrs:{"src":_vm.item.image}})]),_c('span',{staticClass:"benefit-title"},[_vm._v(_vm._s(_vm.item.title))]),_c('p',{staticClass:"benefit-description"},[_vm._v(" "+_vm._s(_vm.item.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }